export enum ProsecutionApprovalPath {
	Execute = 1,
	RaiseToMinister = 2,
}
